const lineHeight = {
  none: "1",
  verytight: "1.13", // 17px
  tight: "1.25",
  snug: "1.375",
  normal: "1.533", // 23px
  relaxed: "1.73", // 26px
  loose: "2.07", // 31px
  veryloose: "2.2", // 33px
  superveryloose: "3", // 45px
  ultraloose: "3.8", // 57px
  3: ".75rem",
  4: "1rem",
  5: "1.25rem",
  6: "1.5rem",
  7: "1.75rem",
  8: "2rem",
  9: "2.25rem",
  10: "2.5rem",
  11: "3.5rem",
  12: "4rem",
}

module.exports = {
  lineHeight,
}

exports.default = lineHeight
